import React from 'react';

import { Dashboard as DashboardView } from 'apps/manager';
import { Items as ItemsView } from 'apps/manager';
// import ItemDetail from './Items/ItemDetail';

const managerRoutes = [
  {
    path: '/manager/dashboard',
    renderer: (params = {}): JSX.Element => <DashboardView {...params} />,
  },
  {
    path: '/manager/dashboard/subscription/:subscriptionid/item/:itemid',
    renderer: (params = {}): JSX.Element => <ItemsView {...params} />,
  },
];

export default managerRoutes;
